import React from 'react'

export default () => (
  <span style={{ color: 'grey' }}>n/a</span>
)
